/**
 * Lightweight session flag for the mobile KV store. Legacy Buxus mobile uses Expo AuthSession + OIDC discovery
 * (local ABP vs OneOK SecureAuth), token exchange, and Redux persistence — see
 * `buxus-frontend/src/modules/user/components/LoginFormContainer.tsx`.
 *
 * This module is storage-only so web (localStorage) and mobile (AsyncStorage)
 * can share the same contract without pulling RN or OIDC into shared.
 */
export const SESSION_AUTH_STORAGE_KEY = 'buxus-session-auth-signed-v1';

/** Cached `get-registration-profile` `data` JSON (web: localStorage; mobile: KV store). */
export const REGISTRATION_PROFILE_JSON_KEY = 'buxus-registration-profile-json-v1';

export type KeyValueStore = {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
  removeItem(key: string): Promise<void>;
};

export async function isSessionAuthSignedIn(store: KeyValueStore): Promise<boolean> {
  const v = await store.getItem(SESSION_AUTH_STORAGE_KEY);
  return v === '1';
}

export async function setSessionAuthSignedIn(store: KeyValueStore): Promise<void> {
  await store.setItem(SESSION_AUTH_STORAGE_KEY, '1');
}

export async function clearSessionAuthSignedIn(store: KeyValueStore): Promise<void> {
  await store.removeItem(SESSION_AUTH_STORAGE_KEY);
}
